import React from 'react'
import styled from 'styled-components'

import { FieldWrapper, Label, StyledError, InputWrapper } from './styles'

export default function TextareaField({ input, meta, placeholder, label, ...props }) {
  return (
    <FieldWrapper>
      {label && <Label htmlFor={input.name}>{label}</Label>}
      <InputWrapper>
        <StyledTextarea {...props} id={input.name} placeholder={placeholder} {...input} rows="6" />
        {meta.touched && meta.error && <StyledError>{meta.error}</StyledError>}
      </InputWrapper>
    </FieldWrapper>
  )
}

export const StyledTextarea = styled.textarea`
  width: 100%;
  padding: 7px 28px 5px 10px;
  border: 2px solid ${({ theme }) => theme.colors.neutral};
  color: ${({ theme }) => theme.colors.blueDark};
`
